import { render, staticRenderFns } from "./VirtualShopDetail.vue?vue&type=template&id=75b91274&scoped=true"
import script from "./VirtualShopDetail.vue?vue&type=script&lang=ts"
export * from "./VirtualShopDetail.vue?vue&type=script&lang=ts"
import style0 from "./VirtualShopDetail.vue?vue&type=style&index=0&id=75b91274&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b91274",
  null
  
)

export default component.exports